import { ApolloError } from 'apollo-client'

export function handleError(error: ApolloError, setError: (error: string) => void) {
  const messages = error.graphQLErrors.map(e => e.message)

  if (messages.includes('registration has already been taken')) {
    setError(`You've already registered for this event.`)
  } else if (messages.includes('capacity_exceeded')) {
    const remainingSpots = error.graphQLErrors.map((e: any) => e.capacity_available)[0]
    const singular = remainingSpots === 1
    setError(
      `There ${singular ? 'is' : 'are'} only ${remainingSpots || 'a few'} ${
        singular ? 'spot' : 'spots'
      } available. Please only register up to the amount available.`,
    )
  } else {
    setError('Something went wrong. Try again.')
  }
}
